import emailjs from '@emailjs/browser';
import { firestore } from "../utils/database";

emailjs.init("user_jzbkzTRjGnVizvlvvPsZG");

const sendEmail = async (recipient_name, recipient_email, link) => {
  // send email to user
  emailjs.send("service_o3aqz0r","template_g0diom5", {
    'to_name': recipient_name,
    'to_email': recipient_email,
    'personal_link': link,
  }, 'user_jzbkzTRjGnVizvlvvPsZG')
    .then((result) => {
      console.log("update email sent ", recipient_name, recipient_email);
      // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior) 
     
    }, (error) => {
        console.log(error.text);
    });
}

export default sendEmail;